import { State, Message } from 'src/app/root-store/event-log-store/state';
import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';

const getMessages = (state: State): Message[] => state.messages;

export const selectEventLogState: MemoizedSelector<object, State> =
  createFeatureSelector<State>('event-log');

export const selectEventLogMessages: MemoizedSelector<object, any> =
  createSelector(selectEventLogState, getMessages);
